import { Fragment, useEffect, useState } from "react";

function ListItemWrapper({
  children,
  onSelected,
  onDeselected,
  header,
  actionButtons,
}) {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  useEffect(() => {
    if (hovered) {
      onSelected();
    } else {
      onDeselected();
    }
  }, [hovered, onDeselected, onSelected]);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="hover:shadow-lg bg-white rounded-lg px-[20px] max-w-[100%]"
    >
      <div className="relative flex items-center justify-between h-[42px]">
        <div>{header}</div>
        <div className={`flex gap-4 w-3/10`}>
          {actionButtons.map((button, i) => (
            <Fragment key={i}>{button}</Fragment>
          ))}
        </div>
      </div>
      {children}
    </div>
  );
}

export default ListItemWrapper;
